class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
  
    const isLevel2 = this.mainDetailsToggle.closest('.mega-menu__links') !== null &&
                     this.mainDetailsToggle.closest('.mega-menu__submenu-content') === null &&
                     this.mainDetailsToggle.querySelector('.mega-menu__submenu-content') !== null;
  
    const megaMenuImages = this.mainDetailsToggle.closest('.mega-menu')?.querySelector('.mega-menu__images');
  
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    const button = this.mainDetailsToggle.querySelector("summary .simple-button");
    
    const siblingList = this.mainDetailsToggle.closest('ul');
    if (siblingList) {
      const directListItems = siblingList.querySelectorAll(":scope > li");
      
      directListItems.forEach(li => {
        const firstLink = li.querySelector(".simple-button");
        if (firstLink) {
          firstLink.classList.toggle("is-inactive");
        }
      });
    }
    
    button.classList.toggle("is-active", isOpen);
    
    // if (!isLevel2) {
    //   document.querySelector(".overlay-blur").classList.toggle("is-active", isOpen);
    // }

    if (isLevel2 && megaMenuImages) {
      if (isOpen) {
        clearTimeout(document.restoreOpacityTimeout);
        document.restoreOpacityTimeout = null;
        megaMenuImages.style.opacity = '0';
        megaMenuImages.style.pointerEvents = 'none';
      } else {
        document.restoreOpacityTimeout = setTimeout(() => {
          megaMenuImages.style.opacity = '1';
          megaMenuImages.style.pointerEvents = 'auto';
          document.restoreOpacityTimeout = null;
        }, 100);
      }
    }
  
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }  
}

customElements.define('header-menu', HeaderMenu);
